import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface TemporaryPaymentSettings {
  membershipEnabled: boolean;
  membershipPriceOnce?: number;
  membershipPriceMonthly?: number;
  membershipPriceYearly?: number;
  membershipDescription?: string;
  membershipTrialDays?: number;
  duesEnabled?: boolean;
  duesPriceOnce?: number;
  duesPriceMonthly?: number;
  duesPriceYearly?: number;
  duesDescription?: string;
}

interface PaymentSettingsState {
  temporarySettings: TemporaryPaymentSettings | null;
}

const initialState: PaymentSettingsState = {
  temporarySettings: null,
};

const paymentSettingsSlice = createSlice({
  name: "paymentSettings",
  initialState,
  reducers: {
    setTemporaryPaymentSettings: (
      state,
      action: PayloadAction<TemporaryPaymentSettings>
    ) => {
      state.temporarySettings = action.payload;
    },
    clearTemporaryPaymentSettings: (state) => {
      state.temporarySettings = null;
    },
  },
});

export const { setTemporaryPaymentSettings, clearTemporaryPaymentSettings } =
  paymentSettingsSlice.actions;
export default paymentSettingsSlice.reducer;
